import React from "react";
import './Footer.css';
import { NavLink } from 'react-router-dom';
import { useTranslation } from "react-i18next";

function Footer() {

  const {t, i18n} = useTranslation("common")

  return (
    <div>
         <footer className="footer-section">
      <header className="footer-header">
        <img
          loading="lazy"
         src="/gregg_logo.png"
         className="footer-header-img"
        />
        <div className="footer-header-description">
          
          {t('navigation.title')}
          
          </div>
      </header>
      <div className="footer-nav-container">
        <div className="footer-nav-items">
          <div className="footer-nav-item">
            <p className="footer-nav-title">

              {t('navigation.about')}

            </p>
          </div>
          <div className="footer-nav-item">
          <NavLink className="footer-nav-link" to={"/about-us"} >
          
            <p>

               {t('navigation.aboutProject')}

            </p>

            </NavLink>
          
          </div>
          <div className="footer-nav-item">
          <NavLink className="footer-nav-link" to={"/contact"} >

            <p>
              {t('navigation.contact')}
            </p>

            </NavLink>

          </div>

          <div className="footer-nav-item">
          <NavLink className="footer-nav-link" to={"/team"} >

            <p>

             {t('navigation.ourTeam')}

            </p>

            </NavLink>

          </div>
        </div>
        <div className="footer-nav-items">
        <div className="footer-nav-item">
            <p className="footer-nav-title">

               {t('navigation.resources')}

            </p>
          </div>
          <div className="footer-nav-item">
          <NavLink className="footer-nav-link" to={"/teacher-resources"} >
          
            <p>

               {t('navigation.teacherResources')}

            </p>

            </NavLink>
          
          </div>
          <div className="footer-nav-item">
          <NavLink className="footer-nav-link" to={"/veteran-interviews"} >

            <p>

             {t('navigation.veteranInterviews')}

            </p>

            </NavLink>

          </div>
        </div>
        <div className="footer-nav-items">
        <div className="footer-nav-item">
            <p className="footer-nav-title">

              {t('navigation.missions')}

            </p>
          </div>
          <div className="footer-nav-item">
          <NavLink className="footer-nav-link" to={"/missions"} >
          
          
            <p>

               {t('navigation.viewMissions')}

            </p>

            </NavLink>
          
          </div>
          <div className="footer-nav-item">
          <NavLink className="footer-nav-link" to={"/about-us"} >

            <p>
              FAQ
            </p>

            </NavLink>

          </div>
        </div>
      </div>
      

    </footer>

    <hr style={{width: '100%'}} />
    <div className="partners" >
           <div className="footer-partners-description">{t('navigation.sponsors')}</div>
            <div className="partners-img-container">
              <div className="partner-item">
                <div className="partner-text">Veterans Affairs Canada</div>
                <a href="https://www.veterans.gc.ca/language_selection_page?destination=/node/117" target="_blank">
                  <img src={t('navigation.vacLogo')} className="ch-img" alt="Partner 2" />
                </a>
              </div>
              <div className="partner-item">
                <div className="partner-text">The Gregg Centre</div>
                <img src="/unb-gregg.jpg" className="unb-gregg-img" alt="Partner 1" />
              </div>
              
              <div className="partner-item">
                <div className="partner-text">Big Ideas Group Consulting Inc.</div>
                <img src="/BIG-logo.jpg" className="ch-img bigidea-img" alt="Partner 3" />
              </div>
              <div className="partner-item">
                <div className="partner-text">{t('navigation.PK75')}</div>
                <a href="https://pk75.ca › canada" target="_blank">
                  <img src="/CPVA_Logo.png" className="ch-img bigidea-img" alt="Partner 3" />
                </a>
              </div>
              <div className="partner-item">
                <div className="partner-text">{t('navigation.Athena')}</div>
                <a href="https://www.projectathena.ca" target="_blank">
                  <img src="/project_athena.png" className="ch-img bigidea-img" alt="Partner 3" />
                </a>
              </div>
              <div className="partner-item">
                <div className="partner-text">{t('navigation.directorateHistory')}</div>
                <a href="https://www.canada.ca/en/department-national-defence/services/military-history/history-heritage.html" target="_blank">
                  <img src="/Canada.png" className="ch-img" alt="Partner 5" />
                </a>
              </div>
            </div>
          {/* <div className="partners-img-container">
            <img src="/unb-gregg.jpg" className="unb-gregg-img" alt="Partner 1" />
            <a href="https://www.veterans.gc.ca/language_selection_page?destination=/node/117" target="_blank"><img src={t('navigation.vacLogo')} className="ch-img"  alt="Partner 2" /></a>
            <img src="/BIG-logo.jpg" className="ch-img bigidea-img" alt="Partner 3" />
          </div> */}
            
    </div>
    <hr style={{width: '100%'}} />
<div className="copyright">


  <p className="copyright-text" >
     &copy; {new Date().getFullYear()}  {t('navigation.copyright')}
  </p>
  
   

</div>


</div>
 
  );
}

export default Footer;

